export async function realradiobutton(fieldId: string, prefixKeyFormatted: string, productId: string, data: { [key: string]: Object }[], hasError: boolean) {

    await import('@syncfusion/ej2-base/styles/bootstrap4.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap4.css');
    await import('@syncfusion/ej2-inputs/styles/bootstrap4.css');
    await import('@syncfusion/ej2-popups/styles/bootstrap4.css');
    await import('@syncfusion/ej2-lists/styles/bootstrap4.css');
    await import('@syncfusion/ej2-dropdowns/styles/bootstrap4.css');

    await import('./loadSyncfusion');

    const { DropDownList } = await import('@syncfusion/ej2-dropdowns');

    const containerEle = document.getElementById('container_' + fieldId);
    const inputEle = document.getElementById('input_' + fieldId);

    const dataEle = document.getElementById('data_' + fieldId);
    if (containerEle.hasAttribute("data-singleradiobutton")) {
        (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
        return;
    }

    containerEle.setAttribute('data-singleradiobutton', 'true');

    let ddObject = new DropDownList({
        dataSource: data,
        fields: { text: 'Text', value: 'Value' },
        value: null,
        change: (args: any) => {
            const fieldId = '@(componentKey)';
            dataEle.setAttribute('value', ddObject.value?.toString());

            ((window as any).htmx as any).trigger('#updatebutton', 'click');
        },
        created: (args: any) => {
            (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
            containerEle.style.display = null;
        }
    });
    ddObject.appendTo('#input_' + fieldId);
}